import { supabase } from "@/supabase";
import { ref } from "vue";
import { AuthService } from "./auth.service";
import { StorageService } from "./storage.service";
import { UsersService } from "./users.service";
import { getPagination } from "../utils/general";
import { storage_url } from "../utils/general";

const _CLIENT = "client";

export const subscribedClient = ref({});
export const setClientSubscription = (client) => {
  subscribedClient.value = client;
}
export const ClientService = {
 async getClient(user_id) {
  const resp = { client: null, error: null };
  const { data: client, error } = await supabase
   .from(_CLIENT)
   .select("*,users!inner(*),client_brands(*,brand(*,company(*)))")
   .eq("user_id", user_id)
   .single();
  if (error) {
   resp.error = error.message;
   return resp;
  }
  if (client) {
   if (client.users?.avatar && client.users.avatar != null ) {
    if (!client.users.avatar.startsWith('http')) {
     client.users.avatar = storage_url + client.users.avatar;
    }
   }
   if (client.client_brands) {
    for (const clientBrand of client.client_brands) {
     if (clientBrand.brand?.logo && clientBrand.brand.logo != null) {
      if (!clientBrand.brand.logo.startsWith('http')) {
       clientBrand.brand.logo = storage_url + clientBrand.brand.logo;
      }
     }
    }
   }
   resp.client = client;
   return resp;
  }
  return resp;
 },
 async getClients(filter = {}, orderBy = {}, page) {
  const clients = { data: null, count: 0, error: null };
  try {
    let select = "*,users!inner(*),client_brands(*,brand(*))"
    if(filter.search_brand_name || filter.brand_id) {
      select = `*,
          users!inner(*),
          client_brands!inner(
            *,
            brand!inner(*)
          )`
    }
   const query = supabase
    .from(_CLIENT)
    .select(select, { count: "exact" });
    if (filter.search_brand_name) {
      query.filter(
        "client_brands.brand.brand_name",
        "ilike",
        `%${filter.search_brand_name}%`
      );
     }
    if(filter.brand_id) {
      query.filter(
        "client_brands.brand_id",
        "eq",
        filter.brand_id
      );
    }
   if (filter.search) {
    query.or(
     `email.ilike.%${filter.search}%, first_name.ilike.%${filter.search}%, last_name.ilike.%${filter.search}%`,
     { foreignTable: "users" }
    );
   }
   
   if (orderBy && orderBy.field) {
    if (orderBy.field?.includes(".")) {
     const [foreignTable, field] = orderBy.field.split(".");
     query.order(field, {
      foreignTable: foreignTable,
      ascending: orderBy.order === "asc" ? true : false,
     });
    } else {
     query.order(orderBy.field, {
      ascending: orderBy.order === "asc" ? true : false,
     });
    }
   }
   if (page > -1) {
    const { from, to } = getPagination(page, 20);
    query.range(from, to);
   }
   const { data, count, error } = await query;
   if (error) {
    clients.error = error.message;
    return clients;
   }
   if(data) {
    for (const client of data) {
      if (client.users?.avatar && client.users.avatar != null) {
        if (!client.users.avatar.startsWith('http')) {
          client.users.avatar = storage_url + client.users.avatar;
        }
      }
      if (client.client_brands) {
      for (const clientBrand of client.client_brands) {
        if (clientBrand.brand?.logo && clientBrand.brand.logo != null) {
          if (!clientBrand.brand.logo.startsWith('http')) {
            clientBrand.brand.logo = storage_url + clientBrand.brand.logo;
          }
        }
      }
      }
    }
  }
   clients.data = data;
   clients.count = count;
   return clients;
  } catch (err) {
   clients.error = err.message;
   return clients;
  }
 },
 async addClient(data) {
  const resp = { created: false, error: null };

  if (data.users?.email) {
   const user = await AuthService.add(data.users.email);
   if (user && user?.id) {
    data.user_id = user?.id;
    data.users.status = true;
    const {
     data: clientObj,
     error: clientObjError,
     brand_ids: brandIds,
    } = await this._updateUserGetClientObject(data);
    if (clientObjError) {
     resp.error = clientObjError.message;
     return resp;
    }
    clientObj.user_id = user?.id;
    clientObj.created_at = new Date();
    const { error: clientError } = await supabase
     .from(_CLIENT)
     .insert(clientObj)
     .single();
    if (brandIds && brandIds.length > 0) {
     const { error: brandError } = await supabase
      .from("client_brands")
      .insert(brandIds.map((brand_id) => ({ brand_id, client_id: user?.id })));
     if (brandError) {
      resp.error = brandError.message;
      return resp;
     }
    }
    if (clientError) {
     resp.error = clientError.message;
     return resp;
    }
    resp.created = true;
    return resp;
   }
  }
  return resp;
 },
 async updateClient(data) {
  const resp = { updated: false, error: null };
  const {
   data: clientObj,
   error: clientObjError,
   brand_ids: brandIds,
  } = await this._updateUserGetClientObject(data);
  if (clientObjError) {
   resp.error = clientObjError;
   return resp;
  }
  if (clientObj) {
   clientObj.updated_at = new Date();
   const { error: staffError } = await supabase
    .from(_CLIENT)
    .update(clientObj)
    .eq("user_id", data.user_id)
    .single();

   if (staffError) {
    resp.error = staffError.message;
    return resp;
   }
  }
  if (brandIds && brandIds.length > 0) {
   const { error: brandError } = await supabase
    .from("client_brands")
    .delete()
    .eq("client_id", data.user_id);
   if (brandError) {
    resp.error = brandError.message;
    return resp;
   }
   const { error: brandError2 } = await supabase
    .from("client_brands")
    .insert(
     brandIds.map((brand_id) => ({ brand_id, client_id: data.user_id }))
    );
   if (brandError2) {
    resp.error = brandError2.message;
    return resp;
   }
  } else {
    const { error: brandError } = await supabase
    .from("client_brands")
    .delete()
    .eq("client_id", data.user_id);
   if (brandError) {
    resp.error = brandError.message;
    return resp;
   }
  }
  resp.updated = true;
  return resp;
 },
 async deleteClient(user_id) {
  console.log(user_id);
  const resp = { deleted: false, error: null };
  const { error: userError } = await supabase
   .from("users")
   .delete()
   .eq("id", user_id);
  if (userError) {
   resp.error = userError.message;
   return resp;
  }
  const { error: clientError } = await supabase
   .from(_CLIENT)
   .delete()
   .eq("user_id", user_id);
  if (clientError) {
   resp.error = clientError.message;
   return resp;
  }
  resp.deleted = true;
  return resp;
 },
 async _updateUserGetClientObject(data) {
  const resp = { data: null, error: null, brand_ids: [] };
  if (data.users?.profile_picture) {
   const { data: file, error } = await StorageService.upload(
    data.users?.profile_picture,
    "avatar"
   );
   if (error) {
    resp.error = error.message;
    return resp;
   }
   if (file) {
    if (data) {
     data.users.avatar = file.path;
    }
   }
  }
  const userObj = {
   user_type: "client",
  };
  if ("status" in data.users) userObj.status = data.users?.status;
  if ("user_id" in data) userObj.id = data.user_id;
  if ("avatar" in data.users) userObj.avatar = data.users?.avatar;
  if ("first_name" in data.users) userObj.first_name = data.users?.first_name;
  if ("last_name" in data.users) userObj.last_name = data.users?.last_name;
  const { error } = await UsersService.updateUser(userObj);
  if (error) {
   resp.error = error.message;
   return resp;
  }

  resp.brand_ids = data.brand_ids;

  const clientObj = {};
  if ("contact_number" in data) clientObj.contact_number = data.contact_number;
  if ("job_title" in data) clientObj.job_title = data.job_title;
  resp.data = clientObj;

  return resp;
 },
};
